import { StreamCallProvider } from '@stream-io/video-react-bindings';

// re-exporting the StreamCallProvider as StreamCall
export const StreamCall = StreamCallProvider;
